import { Column, FileManagerRow, FMColumn } from '../model';

import { PersonCellInner } from '../components/cells/PersonCell';
import { FilterEnumContainer } from '../components/plugins/filters/FilterEnumContainer';
import { Type } from '../../../../general/modules/filter/dataModel';
import { userFullName } from '../../../../general/model';
import { WithLoader } from '../components/cells/WithLoader';

export const managerCol: FMColumn<Type.ID> = {
  key: Column.manager,
  dataKey: Column.manager,
  title: 'Manager',
  width: 160,
  sortable: true,
  cellRenderer: WithLoader(PersonCellInner),
  className: 'ch-file-manager__cell_manager',
  filter: Type.ID,
  plugins: [FilterEnumContainer],
  getter: (n: FileManagerRow) => {
    const mgrUser = n.creative?.customer ?? null;
    if (mgrUser === null) return null;
    return userFullName(mgrUser);
  },
  toDisplayString: (n: FileManagerRow) => {
    const mgrUser = n.creative?.customer ?? null;
    if (mgrUser === null) return null;
    return userFullName(mgrUser);
  },
};
